module.exports = __webpack_public_path__ + "static/img/1.0e92270.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/eng/1.png
// module id = 8GEN
// module chunks = 0